import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import fr from 'vuetify/es5/locale/fr';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#01a95c',
        secondary: '#336699',
        accent: '#663399',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: colors.orange
      }
    }
  },
  lang: {
    locales: {
      fr
    },
    current: 'fr'
  },
});
